import { forwardRef, createElement } from 'react';

function IconInboxSmart(props, svgRef) {
  return createElement("svg", Object.assign({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 4v2H6.918l-2.8 8h3.229a1 1 0 01.916.598l.974 2.22a1 1 0 00.916.599h3.694a1 1 0 00.915-.598l.976-2.221a1 1 0 01.915-.598h3.228l-.525-1.5h2.118l.428 1.22c.065.185.098.38.098.577v3.953a1.75 1.75 0 01-1.607 1.744L20.25 20H3.75A1.75 1.75 0 012 18.25v-3.953c0-.197.033-.392.098-.578L5.09 5.172A1.75 1.75 0 016.742 4H12zm6.167-2.76a.35.35 0 01.631-.074l.036.074 1.145 3.115 3.183.179c.283.016.421.342.286.57l-.043.058-.037.036-2.476 2.104.823 3.226c.073.288-.182.527-.43.46l-.068-.025-.042-.024L18.5 9.121l-2.674 1.816c-.24.163-.535-.018-.552-.286l.003-.075.01-.049.821-3.226-2.475-2.104a.384.384 0 01.088-.637l.068-.02.05-.007 3.183-.179 1.145-3.115z",
    fill: "currentColor"
  }));
}

var InboxSmart = /*#__PURE__*/forwardRef(IconInboxSmart);

export default InboxSmart;
//# sourceMappingURL=InboxSmart.js.map
